import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";


export class PriceList extends GeneralModel {

    hubId: number;
    hub: Hub;
    fuelSurcharge: number;
    remoteSurcharge: number;
    publicDateFrom: Date;
    PublicDateTo: Date;
    isPublic:boolean;

}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/priceList.model.ts